import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Spinner, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

function Loader({ loading }) {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!loading) return null;
  return (
    <div className={styles.overlay}>
      <Spinner label={`${t("loading")}...`} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.backdrop.loading,
  };
};

export default connect(mapStateToProps)(Loader);
